import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthRoutingModule } from './auth-routing.module';
import { AuthPageComponent } from './pages/auth-page/auth-page.component';
import { AuthForgotPasswordPageComponent } from './pages/auth-forgot-password-page/auth-forgot-password-page.component';
import { AuthResetPasswordPageComponent } from './pages/auth-reset-password-page/auth-reset-password-page.component';
import { AuthAccountActivationComponent } from './pages/auth-account-activation/auth-account-activation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthRegisterPageComponent } from './pages/auth-register-page/auth-register-page.component';
import { AuthPageProviderComponent } from './pages/auth-page-provider/auth-page-provider.component';


@NgModule({
  declarations: [
    AuthPageComponent,
    AuthForgotPasswordPageComponent,
    AuthResetPasswordPageComponent,
    AuthAccountActivationComponent,
    AuthRegisterPageComponent,
    AuthPageProviderComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule
  ]
})
export class AuthModule { }
